import { Grid, useMediaQuery } from '@mui/material';

import WebView from './WebView';
import MobileView from './MobileView';

const HowItWorks = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)')

  return (
    <Grid>
        { isSmallScreen ? <MobileView />  :<WebView />}
    </Grid>
  );
};

export default HowItWorks;
